import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "receive-forecast-business" }
const _hoisted_2 = { class: "receive-forecast-business__top-area top-area" }
const _hoisted_3 = { class: "top-area__button-area button-area" }
const _hoisted_4 = {
  key: 0,
  class: "button-area__edit-forecast-for-receipt-button edit-forecast-for-receipt-button"
}
const _hoisted_5 = { class: "edit-base-business-responsible-user__button--container" }
const _hoisted_6 = { class: "edit-base-business-responsible-user__button--text" }
const _hoisted_7 = { class: "create-receive-forecast-button__container" }
const _hoisted_8 = { class: "create-receive-forecast-button__text" }
const _hoisted_9 = { class: "receive-forecast-business__filter-content filter-content" }
const _hoisted_10 = { class: "receive-forecast-business__table-area table-area" }
const _hoisted_11 = { class: "table-area__top-accessory" }
const _hoisted_12 = { class: "table-area__select-month-area select-month-area" }
const _hoisted_13 = { class: "select-month-area__title" }
const _hoisted_14 = {
  key: 0,
  class: "table-area__business-table table-area__business-table--zero-match"
}

import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';
import ControlCustomerPageTab from '../components/ControlCustomerPageTab.vue';
import { CUSTOMER_TAB_ROUTER_INFO, DownloadMenuItems } from '../constants';
import { useBusinessListForecastForReceiptStore } from './useBusinessListForecastForReceiptStore';
import { onMounted, computed, onBeforeMount, ref } from 'vue';
import NewBaseTableContent from '@/corePagesModule/BaseTableContent/NewBaseTableContent.vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { i18n } from '@/i18n';
import EditForecastModal from '../components/EditForecastModal.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import FilterModalButton from '@/corePagesModule/filterModal/FilterModalButton.vue';
import ConfirmModal from '../components/ConfirmModal.vue';
import MonthPicker from '@/corePagesModule/components/MonthPicker.vue';
import Pagination from '@/corePagesModule/components/Pagination.vue';
import SelectInput from '@/corePagesModule/SelectInput';
import { SupplierForecastRepository } from '@/coreInfrastructureModule/Repositories/SupplierForecastRepository';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { isLoading } from '@/coreDomainsModule/uiLoadingState';
import { ForecastForReceiptMenuService } from '../domains/services/forecastForReceiptMenuService';
import ForecastForReceiptSelectInput from '../components/ForecastForReceiptSelectInput.vue';
import ForecastForReceiptMenuDropdown from '../components/ForecastForReceiptMenuDropdown.vue';
import AddBaseBusinessForecastForReceiptModal from '../components/editForecastForReceiptModal/addBaseBusinessForecastForReceipt/AddBaseBusinessForecastForReceiptModal.vue';
import CreateForecastForReceiptModal from '../components/editForecastForReceiptModal/createForecastForReceipt/CreateForecastForReceiptModal.vue';
import UpdateForecastForReceiptModal from '../components/editForecastForReceiptModal/editForecastForReceipt/UpdateForecastForReceiptModal.vue';
import EditForecastForReceiptModal from '../components/editForecastForReceiptModal/editForecastForReceipt/EditForecastForReceiptModal.vue';
import DownloadForecastForReceiptModal from '../components/DownloadForecastForReceiptModal.vue';
import DownloadMenuDropdown from '../components/DownloadMenuDropdown.vue';
import DownloadCustomerForecastModal from '../components/DownloadCustomerForecastModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BusinessListForecastForReceipt',
  setup(__props) {

const t = i18n.t;
const route = useRoute();
const store = useBusinessListForecastForReceiptStore();
const { state } = storeToRefs(store);
const locale = computed(() => i18n.locale);

const {
  onClosedForecastForReceiptActionModal,
  onSelectedForecastForReceiptMenu,
  onAppliedCreateBaseBusinessForecastForReceipt,
  onAppliedAddBaseBusinessForecastForReceipt,
  onAppliedEditBaseBusinessForecastForReceipt,
  onAppliedUpdateBaseBusinessForecastForReceipt,
  onSwitchedEditTargetForecastForReceipt,
  onClickedDeleteFromForecastForReceiptButton,
  onClickedDeleteForecastForReceiptInEditMode,
  onConfirmedDeleteForecastForReceiptInEditMode,
  onCanceledDeleteForecastForReceiptInEditMode,
  onClickRemoveFromForecastInRow,
  onBackToNormalMode,
  getTemplateCustomerForecastExcelDownload,
  updateSelectedForecastForReceiptFormState,
  getFilterItemsValue,
  openDownloadCustomerForecastModal,
  closeDownloadCustomerForecastModal,
  onApplyDownloadCustomerForecast,
} = store;

const supplierForecastRepository = new SupplierForecastRepository();

const isRequiredReloadForecastForReceipts = computed(() => {
  return ForecastForReceiptMenuService.needReloadOnAfterAction(state.value.forecastForReceiptLoadingState.type);
});

onBeforeMount(async () => {
  store.init();

  // ダッシュボードの取引一覧ボタンからの遷移時、受領用内示IDがパスパラメータで渡される
  const forecastForReceiptId = typeof route.params.forecastForReceiptId === 'string' ? route.params.forecastForReceiptId : undefined;
  if (forecastForReceiptId) {
    // 受領用内示を選択状態にする
    await onSwitchedEditTargetForecastForReceipt(forecastForReceiptId);
  }
});

/**
 * 仕入先内示作成ボタンの活性/非活性を切り替える
 * 受領用内示を1つ以上選択している場合のみ有効
 */
const isDisabledCreateForecast = computed((): boolean => {
  return store.tableContentItems === undefined || store.tableContentItems.length === 0;
});

const monthsOptionsDisplayForecast = computed(() => {
  return store.monthsOptionsDisplayForecastNumber.map((monthsOption) => monthsOption + t('unitMonth'));
});

/**
 * 受領用内示編集ボタンの活性/非活性を切り替える
 * 受領用内示を1つ以上選択している場合のみ有効
 */
const isDisabledEditForecast = computed((): boolean => {
  return !state.value.tableContents.checkedDisplayIds || state.value.tableContents.checkedDisplayIds.length === 0;
});

/**
 * ダウンロードメニュードロップダウンの開閉状態
 */
const isOpenDownloadMenuDropdown = ref(false);

/**
 * ダウンロードメニューの項目が選択された際の処理
 * @param item - 選択されたダウンロードメニュー項目
 */
const onSelectedDownloadMenu = (item: DownloadMenuItems) => {
  switch (item) {
    case 'ForecastForReceiptFormat':
      // 受領用内示出力モーダルを表示
      state.value.downloadForecastForReceiptModalState.modalState = true;
      break;
    case 'SalesResultAndCustomerForecast':
      // 客先内示ダウンロードモーダルを表示
      openDownloadCustomerForecastModal();
      break;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ControlCustomerPageTab, {
          class: "top-area__tab-bar",
          "tab-info-object": [..._unref(CUSTOMER_TAB_ROUTER_INFO)]
        }, null, 8, ["tab-info-object"]),
        _createElementVNode("div", _hoisted_3, [
          (_unref(state).pageMode === 'editForecastForReceipt')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(TextButton, {
                  class: "edit-forecast-for-receipt-button--update-name-button",
                  "button-style": 'btn-primary',
                  size: '',
                  disabled: _unref(state).editForecastForReceiptModeState.selectedEditForecastForReceiptId === '',
                  onClick: _cache[0] || (_cache[0] = () => (_unref(state).editForecastForReceiptModeState.updateForecastForReceiptModalState = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('受領用内示情報を編集')), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(TextButton, {
                  class: "edit-forecast-for-receipt-button--delete-from-group-button",
                  "button-style": 'btn-primary',
                  size: '',
                  disabled: _unref(state).tableContents.checkedDisplayIds.length === 0,
                  onClick: _cache[1] || (_cache[1] = () => _unref(onClickedDeleteFromForecastForReceiptButton)())
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('受領用内示情報から外す')), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(TextButton, {
                  class: "edit-forecast-for-receipt-button--delete-forecast-button",
                  "button-style": 'btn-primary',
                  size: '',
                  disabled: 
                _unref(state).editForecastForReceiptModeState.selectedEditForecastForReceiptId === '' ||
                _unref(state).tableContents.loadingState.status.type !== 'zeroMatch'
              ,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(onClickedDeleteForecastForReceiptInEditMode)()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('受領用内示を削除')), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(TextButton, {
                  class: "edit-forecast-for-receipt-button--cancel-button",
                  "button-style": 'btn-cancel',
                  size: '',
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(onBackToNormalMode)()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('元のページに戻る')), 1)
                  ], undefined, true),
                  _: 1
                })
              ]))
            : (_openBlock(), _createBlock(ForecastForReceiptMenuDropdown, {
                key: 1,
                class: "forecast-for-receipt-menu-button forecast-for-receipt-menu-button",
                "is-selected-businesses": _unref(state).tableContents.checkedDisplayIds.length > 0,
                "is-open-prop": _unref(state).isOpenForecastForReceiptMenuDropdown,
                "selected-item-prop": _unref(state).selectedForecastForReceiptMenu,
                "onClick:selectInput": _cache[4] || (_cache[4] = () => (_unref(state).isOpenForecastForReceiptMenuDropdown = true)),
                onClose: _cache[5] || (_cache[5] = () => (_unref(state).isOpenForecastForReceiptMenuDropdown = false)),
                onSelectedItem: _cache[6] || (_cache[6] = 
            (item) => {
              _unref(onSelectedForecastForReceiptMenu)(item);
            }
          )
              }, null, 8, ["is-selected-businesses", "is-open-prop", "selected-item-prop"])),
          _createVNode(TextButton, {
            class: "button-area__edit-base-business-responsible-user__button edit-base-business-responsible-user__button button-area__button button-area__button--fill btn-primary",
            size: '',
            disabled: isDisabledEditForecast.value,
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(state).editForecastModalState = true))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)('取引担当者編集')), 1),
                _createVNode(SvgLoader, {
                  class: "edit-base-business-responsible-user__button--icon",
                  name: "editPen"
                })
              ])
            ], undefined, true),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(TextButton, {
            class: "button-area__create-receive-forecast-button create-receive-forecast-button button-area__button button-area__button--fill btn-primary",
            size: '',
            disabled: isDisabledCreateForecast.value,
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(state).createForecastModalState = true))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)('forecastForReceipt_createSupplierForecast')), 1),
                _createVNode(SvgLoader, {
                  class: "create-receive-forecast-button__icon",
                  name: "plusIconWhite"
                })
              ])
            ], undefined, true),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(DownloadMenuDropdown, {
            class: "button-area__download-menu-dropdown",
            "is-open-prop": isOpenDownloadMenuDropdown.value,
            "onClick:selectInput": _cache[9] || (_cache[9] = () => (isOpenDownloadMenuDropdown.value = true)),
            onClose: _cache[10] || (_cache[10] = () => (isOpenDownloadMenuDropdown.value = false)),
            onSelectedItem: onSelectedDownloadMenu
          }, null, 8, ["is-open-prop"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(ForecastForReceiptSelectInput, {
          class: "filter-content__edit-forecast-for-receipt--select-input",
          "select-input-index": 99,
          "store-tag": 'editForecastForReceiptModeInventoryControl',
          "selected-forecast-for-receipt-id-prop": _unref(state).editForecastForReceiptModeState.selectedEditForecastForReceiptId,
          reload: isRequiredReloadForecastForReceipts.value,
          "use-reset": true,
          "use-teleport": "",
          onSelectedForecastForReceipt: _cache[11] || (_cache[11] = (forecastForReceiptId) => _unref(onSwitchedEditTargetForecastForReceipt)(forecastForReceiptId)),
          onSelectedForecastForReceiptFormState: _cache[12] || (_cache[12] = 
          (forecastForReceiptFormState) => _unref(updateSelectedForecastForReceiptFormState)(forecastForReceiptFormState)
        )
        }, null, 8, ["selected-forecast-for-receipt-id-prop", "reload"]),
        _createVNode(FilterModalButton, {
          "filter-modal-type": 'customerForecast',
          "modal-state": _unref(state).detailFilterModalState,
          "select-input-index": 1,
          "filter-items": _unref(getFilterItemsValue)().value,
          onApply: _cache[13] || (_cache[13] = (filteredContents) => _unref(store).onAppliedDetailFilter(filteredContents))
        }, null, 8, ["modal-state", "filter-items"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('forecastForReceipt_searchReceiveDate')), 1),
            _createVNode(MonthPicker, {
              class: "select-month-area__calendar",
              "model-value": _unref(state).receivedForecastYearMonthInfo,
              locale: locale.value,
              "prop-format": _unref(t)('MonthPickerFormat'),
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_unref(store).onSelectedReceiveMonth($event)))
            }, null, 8, ["model-value", "locale", "prop-format"])
          ]),
          (_unref(state).tableContents.pagingOptions)
            ? (_openBlock(), _createBlock(Pagination, {
                key: 0,
                "paging-options": _unref(state).tableContents.pagingOptions,
                "is-loading": _unref(state).tableContents.loadingState.status.type === 'loading',
                class: "table-area__pagination",
                onOnChangePage: _cache[15] || (_cache[15] = ($event: any) => (_unref(store).onChangePaging($event)))
              }, null, 8, ["paging-options", "is-loading"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(SelectInput), {
            class: "table-area__forecast-length-select",
            index: 22,
            "model-value": _unref(t)('displayMonthsOfData', { month: _unref(state).displayForecastsMonth }),
            placeholder: '',
            label: '',
            "filter-type": 'DISPLAY_MONTH',
            "prop-options": monthsOptionsDisplayForecast.value,
            "is-open-prop": _unref(state).isOpenSelectInputType === 'DISPLAY_MONTH',
            "use-teleport": "",
            "onClick:selectInput": _cache[16] || (_cache[16] = () => (_unref(state).isOpenSelectInputType = 'DISPLAY_MONTH')),
            "onUpdate:valueWithIndex": _cache[17] || (_cache[17] = (_, index) => _unref(store).onSelectedDisplayForecastsMonth(index))
          }, null, 8, ["model-value", "prop-options", "is-open-prop"])
        ]),
        (_unref(state).tableContents.loadingState.status.type === 'zeroMatch')
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(t)('forecastForReceipt_placeholderForZeroMatch')), 1))
          : (_openBlock(), _createBlock(NewBaseTableContent, {
              key: _unref(state).tableContents.renderingKey,
              class: "table-area__business-table table-area__business-table--success",
              "prop-table-content-properties": _unref(state).tableContents.tableHeaders,
              "prop-display-objects": _unref(store).tableContentItems,
              "prop-loading-status": _unref(state).tableContents.loadingState,
              "prop-table-type": 'forecastForReceiptAllBusinessTable',
              onChecked: _cache[18] || (_cache[18] = (checkedDisplayIds) => _unref(store).onCheckedDisplayIds(checkedDisplayIds)),
              onOnClickSort: _cache[19] || (_cache[19] = (sortKey) => _unref(store).sortTableContentItems(sortKey)),
              onOnClickRemoveFromForecast: _cache[20] || (_cache[20] = (displayId) => _unref(onClickRemoveFromForecastInRow)(displayId))
            }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status"]))
      ])
    ]),
    _createVNode(EditForecastModal, {
      "modal-state": _unref(state).editForecastModalState,
      "select-input-index": 23,
      onCloseModal: _cache[21] || (_cache[21] = () => (_unref(state).editForecastModalState = false)),
      onApply: _cache[22] || (_cache[22] = (selectedStaffIdList, _) => _unref(store).onApplyEditForecast(selectedStaffIdList))
    }, null, 8, ["modal-state"]),
    _createVNode(ConfirmModal, {
      "modal-state": _unref(state).createForecastModalState,
      "title-text": _unref(t)('forecastForReceipt_createSupplierForecast'),
      "content-text": `${_unref(t)('forecastForReceipt_descriptionOfCreateSupplierForecast1')}\n${_unref(t)(
      'forecastForReceipt_descriptionOfCreateSupplierForecast2'
    )}`,
      "confirm-button-text": _unref(t)('作成'),
      "deny-button-text": _unref(t)('キャンセル'),
      onCloseModal: _cache[23] || (_cache[23] = ($event: any) => (_unref(state).createForecastModalState = false)),
      onConfirm: _cache[24] || (_cache[24] = ($event: any) => (_unref(store).onConfirmedCreateForecast(_unref(supplierForecastRepository))))
    }, null, 8, ["modal-state", "title-text", "content-text", "confirm-button-text", "deny-button-text"]),
    (_unref(state).downloadForecastForReceiptModalState.modalState)
      ? (_openBlock(), _createBlock(DownloadForecastForReceiptModal, {
          key: 0,
          "modal-state": _unref(state).downloadForecastForReceiptModalState.modalState,
          class: "button-area__download-button",
          onClose: _cache[25] || (_cache[25] = ($event: any) => (_unref(state).downloadForecastForReceiptModalState.modalState = false)),
          onApply: _unref(getTemplateCustomerForecastExcelDownload)
        }, null, 8, ["modal-state", "onApply"]))
      : _createCommentVNode("", true),
    (_unref(state).downloadCustomerForecastModalState.modalState)
      ? (_openBlock(), _createBlock(DownloadCustomerForecastModal, {
          key: 1,
          "modal-state": _unref(state).downloadCustomerForecastModalState.modalState,
          "initial-start-year-month": _unref(state).downloadCustomerForecastModalState.startYearMonth,
          "initial-end-year-month": _unref(state).downloadCustomerForecastModalState.endYearMonth,
          onClose: _unref(closeDownloadCustomerForecastModal),
          onApply: _unref(onApplyDownloadCustomerForecast)
        }, null, 8, ["modal-state", "initial-start-year-month", "initial-end-year-month", "onClose", "onApply"]))
      : _createCommentVNode("", true),
    _createVNode(InfoModal, {
      "modal-state": _unref(isLoading)(_unref(state).createSupplierForecastLoadingState.status),
      icon: "loading",
      "enable-outside-click": false
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('仕入先内示を登録中です。')), 1)
      ]),
      _: 1
    }, 8, ["modal-state"]),
    _createVNode(InfoModal, {
      "modal-state": _unref(state).confirmApplyEditModalState,
      icon: "info",
      "enable-outside-click": false,
      "back-button-label": _unref(t)('キャンセル'),
      "next-button-label": _unref(t)('保存'),
      onOnNext: _unref(store).onAppliedConfirmApplyEdit,
      onOnBack: _unref(store).onCanceledConfirmApplyEdit
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('編集を完了')), 1)
      ]),
      description: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('受領用内示の編集を確定し、変更を保存します。')), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", {
          class: "confirm-edit-modal__footer",
          onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_unref(store).onRevokedConfirmApplyEdit && _unref(store).onRevokedConfirmApplyEdit(...args)))
        }, _toDisplayString(_unref(t)('保存せずに終了')), 1)
      ]),
      _: 1
    }, 8, ["modal-state", "back-button-label", "next-button-label", "onOnNext", "onOnBack"]),
    _createVNode(InfoModal, {
      "modal-state": _unref(isLoading)(_unref(state).forecastForReceiptLoadingState.state.status),
      icon: "loading",
      "enable-outside-click": false
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(ForecastForReceiptMenuService).getLoadingText(_unref(state).forecastForReceiptLoadingState.type)), 1)
      ]),
      _: 1
    }, 8, ["modal-state"]),
    _createVNode(CreateForecastForReceiptModal, {
      "modal-state": _unref(state).selectedForecastForReceiptMenu === 'CreateForecastForReceipt',
      "select-input-index": 25,
      onClose: _unref(onClosedForecastForReceiptActionModal),
      onApply: _cache[27] || (_cache[27] = 
      (newForecastForReceiptInfo) => {
        _unref(onAppliedCreateBaseBusinessForecastForReceipt)(newForecastForReceiptInfo);
      }
    )
    }, null, 8, ["modal-state", "onClose"]),
    _createVNode(AddBaseBusinessForecastForReceiptModal, {
      "modal-state": _unref(state).selectedForecastForReceiptMenu === 'AddBaseBusinessToForecastForReceipt',
      "select-input-index": 26,
      onClose: _unref(onClosedForecastForReceiptActionModal),
      onApply: _cache[28] || (_cache[28] = 
      (selectedForecastForReceiptId) => {
        _unref(onAppliedAddBaseBusinessForecastForReceipt)(selectedForecastForReceiptId);
      }
    )
    }, null, 8, ["modal-state", "onClose"]),
    _createVNode(EditForecastForReceiptModal, {
      "modal-state": _unref(state).selectedForecastForReceiptMenu === 'EditForecastForReceipt',
      "select-input-index": 27,
      onClose: _unref(onClosedForecastForReceiptActionModal),
      onApply: _cache[29] || (_cache[29] = 
      (selectedForecastForReceiptId, selectedForecastForReceiptFormState) => {
        _unref(onAppliedEditBaseBusinessForecastForReceipt)(selectedForecastForReceiptId, selectedForecastForReceiptFormState);
      }
    )
    }, null, 8, ["modal-state", "onClose"]),
    _createVNode(ConfirmModal, {
      "modal-state": _unref(state).deleteForecastForReceiptConfirmModalState,
      "title-text": _unref(t)('受領用内示の削除'),
      "content-text": _unref(t)('選択した受領用内示を削除します。'),
      "confirm-button-text": _unref(t)('削除'),
      "deny-button-text": _unref(t)('キャンセル'),
      onCloseModal: _cache[30] || (_cache[30] = ($event: any) => (_unref(onCanceledDeleteForecastForReceiptInEditMode)())),
      onConfirm: _cache[31] || (_cache[31] = ($event: any) => (_unref(onConfirmedDeleteForecastForReceiptInEditMode)()))
    }, null, 8, ["modal-state", "title-text", "content-text", "confirm-button-text", "deny-button-text"]),
    _createVNode(UpdateForecastForReceiptModal, {
      "modal-state": _unref(state).editForecastForReceiptModeState.updateForecastForReceiptModalState,
      "select-input-index": 29,
      "target-forecast-for-receipt-id": _unref(state).editForecastForReceiptModeState.selectedEditForecastForReceiptId,
      "current-forecast-for-receipt-form-state": _unref(state).editForecastForReceiptModeState.selectedForecastForReceiptFormState,
      onClose: _cache[32] || (_cache[32] = () => (_unref(state).editForecastForReceiptModeState.updateForecastForReceiptModalState = false)),
      onApply: _cache[33] || (_cache[33] = 
      (updateForecastForReceiptInfo) => {
        _unref(onAppliedUpdateBaseBusinessForecastForReceipt)(updateForecastForReceiptInfo);
      }
    )
    }, null, 8, ["modal-state", "target-forecast-for-receipt-id", "current-forecast-for-receipt-form-state"])
  ], 64))
}
}

})